import { createChangeSignal } from "../../shared/state/changeSignal";

/**
 * "Change sets changed here": a person's edits went into a change set, so lists of change
 * sets read again, also in the split view's other pane (WA-10), such as "My open proposals"
 * beside the editor (TR-B3-04). It carries no change set data, only the signal.
 */
const changeSets = createChangeSignal("change-sets");

export const notifyChangeSetsChanged = changeSets.notify;
export const onChangeSetsChanged = changeSets.subscribe;
